const global_config = {
  riskFree: 1.5,
  dividendYield: 0,
  stripeToken: process.env.REACT_APP_DOMAIN === 'tools' ? 'pk_live_ztHDkgOeJa4AXbDCCPY832Bw' : 'pk_test_CkneoAnMQqFdP7sEu0EGVcVZ'
}

export default global_config;


// WEBPACK FOOTER //
// ./src/utils/constants.js